import * as React from 'react';
import type { SVGProps } from 'react';
const SvgChevronRight = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props} data-sentry-element="svg" data-sentry-component="SvgChevronRight" data-sentry-source-file="chevron-right.tsx">
    <g clipPath="url(#chevron-right_svg__a)" data-sentry-element="g" data-sentry-source-file="chevron-right.tsx">
      <path fill="#263E6A" d="M9.41 6 8 7.41 12.58 12 8 16.59 9.41 18l6-6z" data-sentry-element="path" data-sentry-source-file="chevron-right.tsx" />
    </g>
    <defs data-sentry-element="defs" data-sentry-source-file="chevron-right.tsx">
      <clipPath id="chevron-right_svg__a" data-sentry-element="clipPath" data-sentry-source-file="chevron-right.tsx">
        <path fill="#fff" d="M0 0h24v24H0z" data-sentry-element="path" data-sentry-source-file="chevron-right.tsx" />
      </clipPath>
    </defs>
  </svg>;
export default SvgChevronRight;